module.exports = __webpack_public_path__ + "img/edit.fb7f7925.png";